import React, { useEffect, useId, useRef, useState } from 'react';


type Props = {
	trigger: React.ReactElement;
	content: React.ReactNode;
};

export default function Popover({
	trigger,
	content,
}: Props) {
	const [open, setOpen] = useState(false);

	const refRoot = useRef<HTMLDivElement>(null);

	useEffect(() => {

		const onPointerDown = (e: PointerEvent) => {
			const target = e.target as Node | null;
			if (!target) return;

			// если клик вне поповера — закрываем
			if (refRoot.current && !refRoot.current.contains(target)) {
				setOpen(false);
			}
		};

		const onKeyDown = (e: KeyboardEvent) => {
			if (e.key === 'Escape') setOpen(false);
		};

		document.addEventListener('pointerdown', onPointerDown, true);
		document.addEventListener('keydown', onKeyDown);
		return () => {
			document.removeEventListener('pointerdown', onPointerDown, true);
			document.removeEventListener('keydown', onKeyDown);
		};
	}, []);

	const onToggle = () => {
		setOpen(!open);
	}

	return (
		<div ref={refRoot} style={{ position: 'relative', display: 'inline-block' }}>
			<div onClick={onToggle}>
				{trigger}
			</div>

			{open && (
				<div
					role="dialog"
					style={{
						position: 'absolute',
						zIndex: 1000,
						marginTop: 8,
						top: '100%',
						right: 0,
						padding: '8px 10px',
						backgroundColor: '#fff',
						borderRadius:  '8px',
						border: '1px solid #dae4e8',
						maxWidth: '290px',
						maxHeight: '60dvh',
						boxShadow: '#1e242d29'
					}}>
					{content}
				</div>
			)}
		</div>
	);
}
